<template>
  <div class="login">
    <!--ログインコンポーネント-->
    <amplify-authenticator
      v-bind:authConfig="authConfig"
    ></amplify-authenticator>
    <div>
      <p>パスワードは、「数字」「記号」「アルファベット大・小」が必要</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      authConfig: {
        signUpConfig: {
          defaultCountryCode: "81",
          hiddenDefaults: ["phone_number"],
          //hiddenDefaults: ['phone_number','username']
        },
        signUpFields: [
          {
            label: "メールアドレス",
            key: "email",
            required: true,
            type: "email",
            displayOrder: 1,
          },
          {
            label: "パスワード",
            key: "password",
            required: true,
            type: "password",
            displayOrder: 2,
          },
          {
            label: "ユーザ名",
            key: "custom:name",
            required: true,
            type: "text",
            displayOrder: 0,
          },
        ],
      },
    };
  },
};
</script>
<style>
.login {
  text-align: center;
}
.Button__button___1FrBC {
  background-color: green !important;
  min-width: 120px !important;
}
</style>
